if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // // itg dataLayer 
    
        // let tmpName = document.querySelector('body[data-template]').dataset.template,
        //   pageUrl = document.querySelector('#page-data').dataset.url,
        //   userLogin = false,
        //   newCust = true,
        //   userEmail = '',
        //   userMbEmail = '',
        //   userShaEmail = '',
        //   zipCode = '',
        //   custId = '',
        //   itemId = this.querySelector('input[name="id"]').value,
        //   itemQty = this.querySelector('input[name="quantity"]').value,
        //   itemPrice = this.dataset.price;
        
        // if(document.querySelector('#check-customer-data')){
        //   let checkCust = document.querySelector('#check-customer-data').dataset;
        //   userLogin = true;
        //   newCust = false;
        //   userEmail = checkCust.email;
        //   userMbEmail = checkCust.mdemail;
        //   userShaEmail = checkCust.shemail;
        //   zipCode = checkCust.zip;
        //   custId = checkCust.id;
        // }
        // // itg dataLayer end
        
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            // itg dataLayer 
            window.dataLayer.push({
              'event': 'criteo_addtocart',
              'page_name': tmpName,
              'page_url': pageUrl,
              'page_type': tmpName,
              'page_category': tmpName,
              'user_logged_in': userLogin,
              'user_type': 'user',
              'new_customer': newCust,
              'user_email_plain_text': userEmail,
              'user_email_md5': userMbEmail,
              'user_email_sha256': userShaEmail,
              'store_id': 'cosori',
              'zipcode': zipCode,
              'customer_id': custId,
              'criteo.ecommerce': {
                'items': [
                  {
                    'item_id': itemId,
                    'price': itemPrice,
                    'quantity': itemQty
                  } 
                ]
              }
            });
            // itg dataLayer end
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
